const managementSections =
  [
    {
      page: 'importOrderPage',
      id: 'btn_masters',
      code: 'importOrder',
      icon: 'iDocIcon-admin-tools',
      title: 'IMPORT_EXPORT_FILE.IMPORT_ORDER_REGISTER'
    },
    {
      page: 'exportInvoicePage',
      id: 'btn_masters',
      code: 'exportInvoice',
      icon: 'iDocIcon-admin-tools',
      title: 'IMPORT_EXPORT_FILE.EXPORT'
    },
    {
      page: 'ftpRegisterPage',
      id: 'btn_masters',
      code: 'ftpRegister',
      icon: 'iDocIcon-admin-tools',
      title: 'IMPORT_EXPORT_FILE.FTPREGISTER'
    }
  ]

export default managementSections
